import {
  useLogoutMutation,
  useWhoAmIQuery
} from '@frontend/core/lib/modules/authentication'
import { IMAGE_PRESETS } from '@frontend/core/lib/modules/images'
import {
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  themeAtom
} from '@frontend/ui'
import { useAtom } from 'jotai/react'
import { Loader, LogOut } from 'lucide-react'
import { StaticAssetImage } from '../modules/images/components'

export function TopNavUser() {
  const { data: user } = useWhoAmIQuery()
  const [logout, { isLoading: isLogoutLoading }] = useLogoutMutation()

  const [theme, setTheme] = useAtom(themeAtom)

  if (!user) {
    return null
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type='button'
          className='hover:bg-secondary flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors'
        >
          <Avatar className='h-7 w-7 rounded-full'>
            <StaticAssetImage
              src={user.image}
              alt={user.firstName}
              preset={IMAGE_PRESETS.playerThumbnail}
              fallback={
                <AvatarFallback className='rounded-full text-xs'>
                  {user.firstName.charAt(0)}
                </AvatarFallback>
              }
            />
          </Avatar>
          <span className='text-foreground hidden text-sm font-medium md:inline'>
            {user.firstName}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='min-w-48 rounded-lg' align='end'>
        <DropdownMenuLabel className='p-0 font-normal'>
          <div className='flex items-center gap-2 px-2 py-1.5 text-left text-sm'>
            <Avatar className='h-8 w-8 rounded-full'>
              <StaticAssetImage
                src={user.image}
                alt={user.firstName}
                preset={IMAGE_PRESETS.playerThumbnail}
                fallback={
                  <AvatarFallback className='rounded-full'>
                    {user.firstName.charAt(0)}
                  </AvatarFallback>
                }
              />
            </Avatar>
            <div className='grid flex-1 text-left text-sm leading-tight'>
              <span className='truncate font-medium'>
                {user.firstName} {user.lastName}
              </span>
              <span className='text-muted-foreground truncate text-xs'>
                {user.email}
              </span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className='font-normal'>Theme</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={theme}
          onValueChange={(value) => {
            if (value === 'light' || value === 'dark') setTheme(value)
          }}
        >
          <DropdownMenuRadioItem value='light'>Light</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value='dark'>Dark</DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            if (isLogoutLoading) return
            logout()
          }}
        >
          {isLogoutLoading ? (
            <>
              <Loader className='animate-spin' />
              Logging out...
            </>
          ) : (
            <>
              <LogOut />
              Log out
            </>
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
